module.exports = __webpack_public_path__ + "img/txt.24afb260.svg";